export function cleanForDisplay(str: string) {
  return decodeSpecialChars(str);
}

export function decodeSpecialChars(str: string) {
  if(!str) {
    return str;
  }

  const res = [
    { re: /&lt;/gm,   ch: "<"  },
    { re: /&gt;/gm,   ch: ">"  },
    { re: /&amp;/gm,  ch: "&"  },
    { re: /&quot;/gm, ch: "\"" },
    { re: /&#x27;/gm, ch: "'"  },
    { re: /&#x2F;/gm, ch: "/"  },
    { re: /&#x5C;/gm, ch: "\\" }
  ];

  for(let i = 0; i < res.length; i++) {
    str = str.replace(res[i].re, res[i].ch);
  }

  return str;
}

export function replacePlaceholders(template: string, data) {
  return template.replace(/{{(.*?)}}/g, (_, key) => {
    return data[key] !== undefined ? data[key] : '';
  });

  /**
 * USAGE EXAMPLE:
 * const templateString = "Hello, {{name}}! You are {{age}} years old.";
 * const dataObject = { name: "John", age: 30 };
 * const result = replacePlaceholders(templateString, dataObject);
 * console.log(result); // Output: Hello, John! You are 30 years old.
 */
}

/**
 * Loop through an array of objects and sanitize specified key
 */
export function sanitizeData(results, key: string) {
  return (results ?? []).map(result => ({
    ...result,
    [key]: decodeSpecialChars(result[key])
  }));
}

export function sanitizeString(input: string): string {
  return input.replace(/[<>:"\/\\|?*\x00-\x1F.]/g, ""); // eslint-disable-line
}

export function shorten(input: string, maxLen: number = 30): string {
  return input.substring(0, maxLen - 1) + (input.length > maxLen ? "..." : "");
}

export function splitAtUpperCase(input: string): string {
  return input.replace(/([A-Z])/g, " $1").trim();
}

export function toTitleCase(str: string): string {
  return str.split(" ")
    .map((w: string) => w[0].toUpperCase() + w.substring(1))
    .join(" ");
}

export function stringToSlug(str: string) {
  str = str.trim(); //str.replace(/^\s+|\s+$/g, ""); // trim
  str = str.toLowerCase();
  
  // remove accents, swap ñ for n, etc
  const from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  const to   = "aaaaeeeeiiiioooouuuunc------";
  
  for(let i=0; i < from.length; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-"); // collapse dashes

  return str;
}

/**
 * Convert a string to a boolean. 
 * E.g. 
 * - "true" becomes true, 
 * - "false" becomes false 
 * - "null" becomes false 
 * - "0" becomes false 
 * - "1" becomes true
 *
 * @param {String} val: The value to convert to boolean.
 */
export function toBoolean(val: boolean|number|string|null|undefined) { 
  const specialTypes = {
    "false" : false,
    "true"  : true,
    "null"  : null
  };

  for(const type of Object.keys(specialTypes)) {
    if(typeof val === "string" && val.trim().match(new RegExp(`^\\(?${type}\\)?$`))) {
      val = specialTypes[type];
    }
  }

  if(typeof val !== "boolean") {
    val = Boolean(Number(val));
  }

  return val;
}
